<template>
  <el-dialog :width="width" title="撤销" :visible.sync="visible" append-to-body>
    <el-form ref="form" :model="data" :rules="rules" label-width="60px" v-loading="isLoading">
      <el-form-item label="意见" prop="Comment">
        <el-input type="textarea" v-model="data.Comment" placeholder="请输入意见"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="isLoading" @click="onCancel">确 定</el-button>
      <el-button @click="onClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      api: require("@/api/wf/instance").default,
      data: {
        Comment: "",
        InstanceId: 0,
      },
      rules: {
        Comment: [{ required: true, message: "请输入意见" }],
      },
      isLoading: false,
      visible: false,
    };
  },
  computed: {
    width() {
      return this.$store.state.isMB ? "86%" : "500px";
    },
  },
  methods: {
    openCreate(data) {
      this.data.InstanceId = data.InstanceId;
      this.data.Comment = data.Comment;
      this.visible = true;
    },
    onCancel() {
      this.$refs.form
        .validate()
        .then((valid) => {
          if (!valid) return;

          this.isLoading = true;
          this.api.cancel(this.data).then((res) => {
            this.isLoading = false;
            if (res.Code == 0) {
              this.$message({
                customClass: "my-msg",
                type: "success",
                message: res.Msg,
              });
              this.$emit("cancel-success");
              this.visible = false;
            } else {
              this.$message({
                customClass: "my-msg",
                type: "error",
                message: res.Msg,
              });
            }
          });
        })
        .catch(() => {});
    },
    onClose() {
      if (this.isLoading) {
        this.$message({
          customClass: "my-msg",
          type: "warning",
          message: "任务执行中，请稍候",
        });
      } else {
        this.visible = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tree-btn {
  display: inline-block;
  width: 40px;
  text-align: center;
}
</style>